import { useMemo, useSyncExternalStore } from 'react';
import { DocumentPropertyFieldsAreaId } from 'types/dynamic-forms/DocumentPropertyFieldsAreaId';
import { useDocumentStore } from './useDocumentStore';

// Reactive variant of useHasError scoped to the given fields-areas (validates only those areas).
export default function useHasErrorInAreas(areas: DocumentPropertyFieldsAreaId[]): boolean {
  const store = useDocumentStore();

  const callbacks = useMemo(() => {
    return {
      getState: () => store.hasErrorsInAreas(areas),
    };
  }, [store, ...areas]);
  const state = useSyncExternalStore(store.addDataChangedListener, callbacks.getState);

  return state;
}
